import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
// import { useState } from "react";
// import { cancelSubscription } from "../services/admin-services";
// import toastService from "@/services/toastService";
// import { useNavigate } from "react-router-dom";
import warning from "@/assets/admin/icon@3x.webp";
// import { DialogClose } from "@/components/ui/dialog";

interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (email?: string) => Promise<void> | void;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  loadingText?: string;
  email?: string;
}

const ConfirmDialog = ({
  open,
  onOpenChange,
  onConfirm,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  // loadingText = "Processing...",
  email,
}: ConfirmDialogProps) => {
  // const [isLoading, setIsLoading] = useState(false);
  // const navigate = useNavigate();

  // const handleConfirm = async () => {
  //   await onConfirm();
  //   // onOpenChange(false);
  // };

  return (
    <Dialog open={open} onOpenChange={(val) => /* !isLoading && */ onOpenChange(val)}>
      <DialogContent className="w-[30%] max-w-[900px] p-0 flex flex-col  rounded-xl overflow-hidden bg-white">
        <DialogHeader className="bg-[#f4f4f4] text-[#181818] font-medium text-[45px] px-6 py-6 leading-normal ">
          {title && <DialogTitle>{title}</DialogTitle>}

        </DialogHeader>
        {description && (
          <DialogDescription>
            <div className="flex flex-col items-center justify-center text-center px-6 py-4 space-y-4">
              <img src={warning} alt="Warning" className="w-20 h-20" />
              <p className="text-[#363636] text-[16px] leading-[24px] ">
                {description}
              </p>
            </div>
          </DialogDescription>
          
        )}
        <DialogFooter className="flex w-full gap-4  border-t  border-gray-200 p-3 ">
          <Button
            variant="ghost"
            className="border w-1/2"
            size="lg"
            // disabled={isLoading}
            onClick={() => onOpenChange(false)}
          >
            {cancelText}
          </Button>
          <Button
            className="w-1/2 !bg-charcoal !text-white font-medium"
            variant="outline"
            size="lg"
            // disabled={isLoading}
            onClick={()=>onConfirm(email)}
          >
            { confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
